"use strict";

require("core-js/modules/es6.array.map");

var _classCallCheck = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbsorbersPlugin = void 0;

var tslib_1 = require("tslib");

var Absorbers_1 = require("./Absorbers");

var Utils_1 = require("../../Utils");

var Enums_1 = require("./Enums");

var Absorber_1 = require("./Options/Classes/Absorber");

var AbsorbersPlugin =
/*#__PURE__*/
function () {
  function AbsorbersPlugin() {
    _classCallCheck(this, AbsorbersPlugin);

    this.id = "absorbers";
  }

  _createClass(AbsorbersPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new Absorbers_1.Absorbers(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      if (options === undefined) {
        return false;
      }

      var absorbers = options.absorbers;
      var loadAbsorbers = false;

      if (absorbers instanceof Array) {
        if (absorbers.length) {
          loadAbsorbers = true;
        }
      } else if (absorbers !== undefined) {
        loadAbsorbers = true;
      } else if (((_c = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.mode) && Utils_1.Utils.isInArray(Enums_1.AbsorberClickMode.absorber, options.interactivity.events.onClick.mode)) {
        loadAbsorbers = true;
      }

      return loadAbsorbers;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      var _a, _b;

      if (!this.needsPlugin(options) && !this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;

      if (source === null || source === void 0 ? void 0 : source.absorbers) {
        if ((source === null || source === void 0 ? void 0 : source.absorbers) instanceof Array) {
          optionsCast.absorbers = source === null || source === void 0 ? void 0 : source.absorbers.map(function (s) {
            var tmp = new Absorber_1.Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          var absorberOptions = optionsCast.absorbers;

          if ((absorberOptions === null || absorberOptions === void 0 ? void 0 : absorberOptions.load) === undefined) {
            optionsCast.absorbers = absorberOptions = new Absorber_1.Absorber();
          }

          absorberOptions.load(source === null || source === void 0 ? void 0 : source.absorbers);
        }
      }

      var interactivityAbsorbers = (_b = (_a = source === null || source === void 0 ? void 0 : source.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.absorbers;

      if (interactivityAbsorbers) {
        if (interactivityAbsorbers instanceof Array) {
          optionsCast.interactivity.modes.absorbers = interactivityAbsorbers.map(function (s) {
            var tmp = new Absorber_1.Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          var _absorberOptions = optionsCast.interactivity.modes.absorbers;

          if ((_absorberOptions === null || _absorberOptions === void 0 ? void 0 : _absorberOptions.load) === undefined) {
            optionsCast.interactivity.modes.absorbers = _absorberOptions = new Absorber_1.Absorber();
          }

          _absorberOptions.load(interactivityAbsorbers);
        }
      }
    }
  }]);

  return AbsorbersPlugin;
}();

var plugin = new AbsorbersPlugin();
exports.AbsorbersPlugin = plugin;

tslib_1.__exportStar(require("./Enums"), exports);